const storageKey = 'crossword-complete-time';

let completeTimes: Record<string, number> | null = null;

export function setCompleteTime(puzzleId: string, time: number) {
  const data = getAllCompleteTimes();
  if (data[puzzleId] && data[puzzleId] < time) return;
  data[puzzleId] = time;
  saveCompleteTimes(data);
}

export function getAverageTimeForPuzzles(puzzleIds: string[]): number {
  const times = puzzleIds.map((puzzleId) => getAllCompleteTimes()[puzzleId]).filter(Boolean);
  if (times.length === 0) return 0;
  return times.reduce((prev, current) => prev + current) / times.length;
}

export function getAllCompleteTimes(): Record<string, number> {
  if (completeTimes === null) {
    try {
      const data = localStorage.getItem(storageKey);
      completeTimes = data ? JSON.parse(data) : {};
    } catch (e) {
      console.warn(e);
      completeTimes = {};
    }
  }

  return completeTimes!;
}

function saveCompleteTimes(data: Record<string, number>): void {
  try {
    localStorage.setItem(storageKey, JSON.stringify(data));
  } catch (e) {
    console.warn(e);
  }
}
